import React from 'react';
import { useState, useEffect } from 'react';
import Button from '../../../components/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import { TextInput } from './Inputs';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Typography from '@material-ui/core/Typography';

export default function PasswordDialog({open, onCancel, onSubmit}) {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => setPassword(''), [open]); // clear password on open and close

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Password Required</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" gutterBottom>
          Please confirm your change by entering your current password.
        </Typography>
        <TextInput
          id="password"
          autoFocus
          value={password}
          onChange={e=>setPassword(e.target.value)}
          placeholder="Current password"
          type={showPassword ? 'text' : 'password'}
          autoComplete="current-password"
          fullWidth
          onKeyUp={e => e.keyCode === 13 && password !== '' && onSubmit(password)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
      </DialogContent>
      <DialogActions style={{width: '100%', paddingLeft: '1.5rem', display: 'flex', justifyContent: 'space-between'}}>
        <Button
          label="Cancel"
          onClick={onCancel}
          color="primary"
          variant="outlined"
          pointer="none"
          style={{width: '7rem'}}
        />
        <Button
          label="OK"
          disabled={password===''}
          onClick={()=>onSubmit(password)}
          color="primary"
          variant="contained"
          pointer="none"
          style={{width: '7rem'}}
        />
      </DialogActions>
    </Dialog>
  );
}

PasswordDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
